import React from "react";
import { Coins, IndianRupee } from "lucide-react";
import { Card } from "@/components/ui/card";
import { formatINR } from "@/lib/api";
import { grams, goldBalanceClass, inrBalanceClass } from "@/pages/admin/suppliers/supplierHelpers";

export const SuppliersSummaryCards = ({ ledgerTotals }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
    <Card className="p-4">
      <div className="flex items-center gap-2 text-muted-foreground text-sm"><Coins className="h-4 w-4 text-[#7A1F1F]" /> Total Gold Payable</div>
      <div data-testid="supplier-total-gold-payable" className={`text-2xl font-semibold mt-1 font-mono ${goldBalanceClass(ledgerTotals.total_gold_fine_g)}`}>{grams(ledgerTotals.total_gold_fine_g)}</div>
      <div className="text-xs text-muted-foreground">fine (24K) — owed to suppliers</div>
    </Card>
    <Card className="p-4">
      <div className="flex items-center gap-2 text-muted-foreground text-sm"><IndianRupee className="h-4 w-4 text-[#7A1F1F]" /> Total Cash Payable</div>
      <div data-testid="supplier-total-cash-payable" className={`text-2xl font-semibold mt-1 font-mono ${inrBalanceClass(ledgerTotals.total_inr)}`}>{formatINR(ledgerTotals.total_inr)}</div>
      <div className="text-xs text-muted-foreground">owed to suppliers</div>
    </Card>
  </div>
);
